import { render, staticRenderFns } from "./WaveletSettings.vue?vue&type=template&id=7448c41f"
import script from "./WaveletSettings.vue?vue&type=script&lang=js"
export * from "./WaveletSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports